/* eslint-disable */
export default {
  log: 'Registro',
} as const;

// @key: @#@"log"@#@ @source: @#@"Log"@#@
